export default __webpack_public_path__ + "static/media/search.cc51b702.svg";